import { Livechat } from "@api";
import { ILivechatGuestCustomFieldAPI } from "@ams/rocket-sdk";
import { IGrantUserParams, IUser } from "@types";
import { compact, isEmpty } from "lodash";

export const grantUser = async (
  token: string,
  params: IGrantUserParams,
  metadata?: Record<string, any>,
) => {
  const customFieldArr: ILivechatGuestCustomFieldAPI[] = [];
  for (const [key, value] of Object.entries(params)) {
    if (!value) {
      continue;
    }
    customFieldArr.push(generateCustomField(key, value, true));
  }
  if (!isEmpty(metadata)) {
    customFieldArr.push({
      key: "metadata",
      value: JSON.stringify(metadata),
      overwrite: true,
    });
  }
  const result: IUser = await Livechat.grantVisitor({
    visitor: {
      token,
      customFields: compact(customFieldArr),
    },
  });
  return result;
};

export const generateCustomField = (
  key: string,
  value: string,
  isOverwrite: boolean,
) => {
  return {
    key,
    value,
    overwrite: isOverwrite,
  };
};
